/**
 * useCreditPayments
 * Fetches collection records for a specific credit using the backoffice
 * endpoint GET /credit-worker/backoffice/credits/{creditId}/collection-records.
 */
import { useQuery } from '@tanstack/react-query';
import { getCreditCollectionRecords } from '@/services/credit-worker.service';

export function useCreditPayments(creditId: string) {
  const query = useQuery({
    queryKey: ['credit', 'collection-records', creditId],
    queryFn: () => getCreditCollectionRecords(creditId),
    enabled: Boolean(creditId),
  });

  return {
    records: query.data?.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
